import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import util from "../../../../global/utils/Helpers";
import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  FETCH_ALL_APPIAN_ICERT_CASES,
  fetchAllAppianICertCasesSuccess,
  fetchAllAppianICertCasesFail,
} from "../actions/actions";
polyfill();

let apiIndex = util.isLocalhost() ? "http://localhost:9393/auth/graphql" : `${util.getCurrentHost()}/auth/auth/graphql`;

const getQuery = (params) => {
  return JSON.stringify({
    query: `
      query {
        getApianICERTCases(
          caseNumber: "${params.caseNumber}"
        )
      }`,
  });
};

// localhost:3214/api/case_platform/icerts
const fetchICertCasesEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_ALL_APPIAN_ICERT_CASES),
    mergeMap(function (action) {
      let { caseNumber } = action.payload;
      let params = {
        caseNumber,
      };

      return fetch(apiIndex, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(params),
      })
        .then((response) => response.json())
        .then(function (data) {
          return fetchAllAppianICertCasesSuccess(JSON.parse(data.data.getApianICERTCases));
        })
        .catch((error) => fetchAllAppianICertCasesFail(true));
    })
  );

export default fetchICertCasesEpic;
